import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// L'access token (JWT) dura 60 minuti; senza questo interceptor, qualunque
// richiesta fatta dopo la scadenza (es. download di un file durante una
// sessione lunga) falliva con 401 anche se il refresh_token (7 giorni) era
// ancora valido. Qui intercettiamo il 401, rinnoviamo l'access token via
// /auth/refresh e ripetiamo automaticamente la richiesta originale una volta.
let refreshPromise = null;
let redirectingToLogin = false;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    const isAuthEndpoint = config?.url?.startsWith("/auth/");
    if (response?.status === 401 && config && !config._retry && !isAuthEndpoint) {
      config._retry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = api.post("/auth/refresh").finally(() => {
            refreshPromise = null;
          });
        }
        await refreshPromise;
        return api(config);
      } catch (refreshError) {
        // Il refresh_token e' scaduto/assente: la sessione e' morta per davvero,
        // non e' recuperabile in silenzio. Reindirizziamo al login invece di
        // lasciar comparire un errore generico (es. "Errore nel download") che
        // nasconde la vera causa (sessione scaduta) e sembra un bug ricorrente.
        if (!redirectingToLogin && window.location.pathname !== "/login") {
          redirectingToLogin = true;
          window.location.href = "/login?session_expired=1";
        }
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

const FIELD_LABELS = {
  name: "Nome e cognome",
  email: "Email",
  password: "Password",
  company: "Ragione sociale",
  vat_number: "Partita IVA",
  tax_code: "Codice Fiscale",
  address: "Indirizzo",
  city: "Città",
  zip_code: "CAP",
  province: "Provincia",
  sdi_code: "Codice SDI",
  pec: "PEC",
  phone: "Telefono",
  message: "Messaggio",
};

function translateError(e) {
  const field = Array.isArray(e.loc) ? e.loc[e.loc.length - 1] : null;
  const label = FIELD_LABELS[field];
  const raw = (e.msg || "").replace(/^Value error,\s*/i, "");
  const min = e.ctx?.min_length;
  const max = e.ctx?.max_length;
  let msg = raw;
  if (e.type === "string_too_short") msg = `deve avere almeno ${min} caratteri`;
  else if (e.type === "string_too_long") msg = `non può superare ${max} caratteri`;
  else if (e.type === "missing") msg = "campo obbligatorio";
  else if (/valid email address/i.test(raw)) msg = "indirizzo email non valido";
  return label ? `${label}: ${msg}` : msg;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e === "object" ? translateError(e) : String(e)))
      .filter(Boolean)
      .join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
